var map = {
	"./amex.png": 1043,
	"./diners.png": 1044,
	"./discover.png": 1045,
	"./jcb.png": 1046,
	"./maestro.png": 1279,
	"./mastercard.png": 1047,
	"./stripe.png": 1048,
	"./union.png": 1049,
	"./unknown.png": 716,
	"./visa.png": 1050
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1278;